import React, { createRef, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  postEligibilityRequest,
  postValidateEligibiltyRequest,
  postValidateEligibiltySuccess,
  updateEligibiltyRequest,
} from '../../containers/clients/eligibility-redux/actions';
import moment from 'moment-timezone';
import Spinner from '../common/spinner';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import { DropDown } from '../common';
import Modal from '../common/modal';
import { UserRole } from '../../containers/navigation-bar/roles';
import useAuth from '../../hooks/useAuth';

type EligibiltyValidationResponse = {
  record_count: number;
  members_to_add: any[];
  existing_members: any[];
  members_to_remove: any[];
  invalid_records: any[];
  headers_errors: string[] | null;
};

type props = {
  clientId?: any;
  handleModel: (isShow: boolean) => void;
  pending: any;
  validation: EligibiltyValidationResponse;
  handleUpload: () => void;
  eligibilityId: number;
  handleValidationViewModel: (data: any) => void;
  uploadLiveTime: any;
  display: boolean;
  eligibilityActiveAndScheduleList: any;
};

const EligibilityFileUpload: React.FunctionComponent<props> = (props): JSX.Element => {
  const { clientId } = props;
  const fileInput: any = createRef();
  const dispatch = useDispatch();
  const [csvFile, setCsvPreview] = useState<any>();
  const [fileName, setfileName] = useState('Upload file');
  const [scheduledDate, setscheduledDate] = useState('');
  const [timeOftheday, settimeOftheday] = useState<any>();
  const [, seterror] = useState(false);
  // const clientId = localStorage.getItem('clientid');
  const startdate = moment(new Date()).startOf('month');
  const [liveDates, setLiveDates] = useState<any>([]);
  const [isDisplay, setIsDisplay] = useState<boolean>(true);
  const [eligibilityId, setEligibilityId] = useState<number>(props.eligibilityId);
  const { roleType: userType } = useAuth();

  const validation = props.validation || null;
  const hadleCsvInput = (e: any) => {
    fileInput.current.click();
  };

  const onFileChange = async (event: any) => {
    try {
      if (event.target.files && event.target.files[0]) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          setCsvPreview(e.target.result);
        };
        reader.readAsDataURL(event.target.files[0]);
        setfileName(event.target.files[0].name);
      }
    } catch (error) {
      console.error('err--', error);
    }
  };

  const handleTimeValueChange = (value: any) => {
    if (value) settimeOftheday(value);
    else settimeOftheday(moment());
  };
  useEffect(() => {
    if (timeOftheday) {
      seterror(false);
    }
  }, [timeOftheday]);
  const handleValidate = () => {
    const linkInput = {
      clientId,
    };
    const payload = {
      eligibility_file: csvFile,
    };
    dispatch(postValidateEligibiltyRequest({ linkInput, payload }));
  };

  const handleUpload = () => {
    let linkInput: any = {
      clientId,
    };

    const useDate = moment(scheduledDate);
    const time = timeOftheday.format('HH:mm:00');
    const timeAndDate = moment(scheduledDate + ' ' + time);

    const timeOfDayString = (
      timeAndDate ? timeAndDate.utc() : moment.tz('US/Central').set({ hour: 4, minute: 0 }).tz('UTC')
    ).format('HH:mm:00');
    const scheduledAt = `${useDate.utc().format('YYYY-MM-DD')} ${timeOfDayString}`;
    const payload: any = {
      scheduled_at: scheduledAt,
      eligibility_file: csvFile,
    };
    const findByDate = props.eligibilityActiveAndScheduleList?.find(
      (item: any) => item.billing_cycle === scheduledDate,
    );
    if (findByDate && !eligibilityId) {
      setIsDisplay(true);
      setEligibilityId(findByDate?.id);
      return;
    }
    if (eligibilityId) {
      linkInput['eligibilityId'] = eligibilityId;
      dispatch(updateEligibiltyRequest({ linkInput, payload }));
    } else {
      dispatch(postEligibilityRequest({ linkInput, payload }));
    }
  };

  useEffect(() => {
    if (props.validation) {
      dispatch(postValidateEligibiltySuccess({}));
    }
    let monthArray = [];
    let month: any = startdate.month();
    const lastMonth: number = month + 11;
    for (month; month < lastMonth; month++) {
      monthArray.push(startdate.add(1, 'M').format('YYYY-MM-DD'));
    }
    setLiveDates(monthArray);
  }, []); //eslint-disable-line

  useEffect(() => {
    if (props.uploadLiveTime && liveDates) {
      const date = new Date(props.uploadLiveTime?.substring(0, 19));
      var local = moment(props.uploadLiveTime).local();
      settimeOftheday(moment(local, 'HH:mm'));
      if (props.eligibilityId) {
        setscheduledDate(moment(date).format('YYYY-MM-DD'));
      }
    }
  }, [props.uploadLiveTime, liveDates]); //eslint-disable-line

  useEffect(() => {
    if (scheduledDate === '' && liveDates.length) {
      setscheduledDate(liveDates[0]);
    }
  }, [liveDates, scheduledDate]);

  useEffect(() => {
    setIsDisplay(props.display);
  }, [props.display]);

  return (
    <div>
      {props.pending && <Spinner />}
      <div
        className={
          'fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none' +
          (isDisplay && ' hidden')
        }
      >
        <div className="min-w-3xl relative mx-auto my-6 w-auto max-w-5xl">
          <div className="relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between">
              <div className="blue-primary px-10 pt-10 text-2xl">Upload Eligibility File</div>
            </div>
            <div className="relative flex-auto px-10 py-5">
              <p className="text-gray-dark mb-4 h-full text-base font-normal leading-relaxed">
                Set the day {userType === UserRole.admin && 'and time'} for the new members to be activated
              </p>
            </div>
            <table className="table-row-format relative mx-10 table-fixed border-collapse">
              <thead className="h-full bg-white">
                <tr className="px-7 text-left">
                  <th className="text-gray-dark sticky top-0 mb-4 h-full w-1/2 bg-white px-2 py-2 text-base font-normal">
                    Live Date
                  </th>
                  <th className="text-gray-dark sticky top-0 mb-4 h-full w-1/2 bg-white px-2 py-2 text-base font-normal">
                    {userType === UserRole.admin ? 'Live Time' : 'File'}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="h-2"></tr>
                <tr
                  role="button"
                  className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white text-left"
                  data-testid="schedule-date-dropdown"
                >
                  <td className="text-gray-dark text-bold border-bottom w-1/2 pr-7 font-bold">
                    <div className="w-full">
                      <DropDown
                        Label={''}
                        value={scheduledDate}
                        setValue={setscheduledDate}
                        data-testid="schedule-date-dropdown-option"
                      >
                        {liveDates.length && liveDates.map((date: any) => <option value={date}>{date}</option>)}
                      </DropDown>
                    </div>
                  </td>
                  {userType === UserRole.admin ? (
                    <td className="text-gray-dark text-bold border-bottom w-1/2 font-bold">
                      <div className="w-full">
                        <TimePicker
                          use12Hours
                          showSecond={false}
                          className={'w-full'}
                          onChange={handleTimeValueChange}
                          value={timeOftheday ? timeOftheday : moment().local()}
                          data-testid="schedule-time-picker"
                        />
                      </div>
                    </td>
                  ) : (
                    <td className="text-gray-dark text-bold border-bottom w-1/2 pr-1 font-bold">
                      <div
                        className="text-gray-dark bg-gray-background-light flex w-full appearance-none items-center rounded-md px-3 py-2 text-sm font-extrabold leading-4 focus:outline-none"
                        onClick={hadleCsvInput}
                        role="button"
                        data-testid="file-button"
                      >
                        {fileName}
                      </div>
                      <input
                        ref={fileInput}
                        id="file-upload"
                        type="file"
                        className="hidden"
                        onChange={onFileChange}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
            {userType === UserRole.admin && (
              <table className="table-row-format relative mx-10 table-fixed border-collapse">
                <thead className="h-full bg-white">
                  <tr className="px-7 text-left">
                    <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                      File
                    </th>
                    {userType === UserRole.admin && (
                      <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal"></th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  <tr className="h-2"></tr>

                  <tr
                    role="button"
                    className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white text-left"
                  >
                    <td className="text-gray-dark text-bold border-bottom w-10/12 pr-1 font-bold">
                      <div
                        className="text-gray-dark bg-gray-background-light flex w-full appearance-none items-center rounded-md px-3 py-2 text-sm font-extrabold leading-4 focus:outline-none"
                        onClick={hadleCsvInput}
                        role="button"
                        data-testid="file-upload-button"
                      >
                        {fileName}
                      </div>
                      <input
                        ref={fileInput}
                        id="file-upload"
                        type="file"
                        className="hidden"
                        onChange={onFileChange}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        data-testid="file-upload"
                      />
                    </td>

                    <td className="text-gray-dark text-bold border-bottom w-2/12 font-bold">
                      <div className="flex items-center justify-center p-1">
                        {csvFile && (
                          <button
                            onClick={handleValidate}
                            className={
                              'flex w-24 items-center justify-center rounded-md px-3 py-2 text-center text-sm text-white ' +
                              (fileName.length > 1 ? 'btn-darkblue' : 'bg-gray-light')
                            }
                            data-testid="validate-button"
                          >
                            VALIDATE
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {(!props.eligibilityId || csvFile) && userType === UserRole.admin && (
              <table className="table-row-format relative mx-10 my-5 table-fixed border-collapse">
                <thead className="h-full bg-white">
                  <tr className="w-full px-7 text-left">
                    <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-1 text-base font-normal">
                      Members
                    </th>

                    <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                      New
                    </th>
                    <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-1 text-base font-normal">
                      Existing
                    </th>
                    <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                      Removed
                    </th>
                    <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                      Invalid
                    </th>

                    <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal"></th>
                  </tr>
                </thead>
                <tbody>
                  {/* <tr className="h-2"></tr> */}
                  {new Array(1).fill(1).map((item: any, index: any) => {
                    return (
                      <tr className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white text-left">
                        <td className="text-gray-dark text-bold border-bottom w-2/12 py-1 text-base font-bold">
                          {validation?.record_count || 0}
                        </td>

                        <td className="border-bottom w-2/12 py-1">
                          <div className="flex">
                            <p className="text-gray-dark text-bold pr-2 text-base font-bold" data-testid="new-count">
                              {validation?.members_to_add?.length || 0}
                            </p>
                          </div>
                        </td>
                        <td className="border-bottom w-2/12 py-1">
                          <p className="text-gray-dark text-bold pr-2 text-base font-bold" data-testid="existing-count">
                            {validation?.existing_members?.length || 0}
                          </p>
                        </td>
                        <td className="border-bottom w-2/12 py-1">
                          <p className="text-gray-dark text-bold pr-2 text-base font-bold" data-testid="removed-count">
                            {validation?.members_to_remove?.length || 0}
                          </p>
                        </td>
                        <td className="border-bottom w-2/12 py-1">
                          <p className="text-gray-dark text-bold pr-2 text-base font-bold" data-testid="invalid-count">
                            {validation?.invalid_records?.length || 0}
                          </p>
                        </td>

                        <td className="border-bottom w-2/12 py-1">
                          {/* <button className="rounded-full  py-1 text-sm  text-white w-20 text-center stacked-bar-red-primary" >FIX </button> */}
                          {validation && (
                            <div
                              className="stacked-bar-green-primary w-20 rounded-full py-1 text-center text-sm text-white"
                              // onClick={() => props.handleModel(true)}
                            >
                              PASS
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            {validation && (!props.eligibilityId || csvFile) && userType === UserRole.admin && (
              <>
                <div className="flex items-center justify-center p-3">
                  <button
                    className="bg-gray-light flex w-24 items-center justify-center rounded-md px-3 py-2 text-center text-sm text-white"
                    onClick={() => props.handleValidationViewModel(validation)}
                    disabled={validation ? false : true}
                    data-testid="eligibility-file-upload-view-button"
                  >
                    VIEW
                  </button>
                </div>
              </>
            )}
            {(props.eligibilityId && !csvFile) ||
            (validation && csvFile) ||
            (userType === UserRole.client_admin && csvFile) ? (
              <div
                className={`flex items-center justify-center pt-6 ${validation?.headers_errors && validation.headers_errors.length > 0 ? 'opacity-50' : ''}`}
              >
                <button
                  disabled={validation?.headers_errors && validation.headers_errors.length > 0 ? true : false}
                  className="btn-darkblue px-7 py-2 text-sm"
                  onClick={handleUpload}
                  data-testid="upload-button"
                >
                  UPLOAD
                </button>
              </div>
            ) : null}

            <div className="flex items-center justify-center p-6">
              <button
                className="bg-gray-light text-cente rounded-full px-7 py-2 text-sm text-white"
                type="button"
                onClick={() => props.handleModel(false)}
                data-testid="cancel-eligibility-upload-button"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isModel={isDisplay}
        InnerComponent={
          <div className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                    Alert
                  </h3>
                  <div className="mt-2 flex">
                    <p className="flex items-center text-sm text-gray-500">
                      Eligibility data for billing cycle {scheduledDate} exists, Do you want to replace the file?
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={handleUpload}
                className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                data-testid="duplicate-billing-cycle-replace-button"
              >
                Replace
              </button>
              <button
                type="button"
                className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                onClick={() => {
                  setIsDisplay(false);
                  setEligibilityId(0);
                }}
                data-testid="duplicate-billing-cycle-cancel-button"
              >
                Cancel
              </button>
            </div>
          </div>
        }
      ></Modal>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    pending: state.eligibility.pending || null,
    validation: state.eligibility.eligibiltyValidation?.data || null,
  };
};

export default connect(mapStateToProps)(EligibilityFileUpload);
